import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import templateContentDetailsImagePageDetailsSubPage from "templates/contentDetailsImagePageDetailsSubPage.hbs";

class ContentDetailsImagePageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  get template() {
    return templateContentDetailsImagePageDetailsSubPage;
  }
}

export default ContentDetailsImagePageDetailsSubPageView;
